import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";
import ButtonComponent from "./ButtonComponent";

const ApiRequestButton = ({
  onButtonClick,
  isLoading,
  tag = "Submit",
  disabled = false,
  borderColor = "#fcd800 1px solid",
  backgroundColor= "#fcd800",
  textColor= "#001317",
  disabledBorderColor,
  disabledBackgroundColor,
  disabledTextColor

}) => {
  // state to show spinner on request progress
  const [showSpinner, setShowSpinner] = useState(false);
  // event handler for click
  const onClickEvent = () => {
    // show spinner during request progress
    setShowSpinner((showSpinner) => (showSpinner = true));
    // call function that is passed in parameters (must be a promise with no arguments)
    onButtonClick()
      .then((res) => {
        console.log(res);
        // hide spinner on request completion
        setShowSpinner((showSpinner) => (showSpinner = false));
      })
      .catch((err) => {
        console.log(err);
        // hide spinner on request completion
        setShowSpinner((showSpinner) => (showSpinner = false));
      });
  };
  // render
  return (
    <>
      {isLoading ? (
        <>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={"40px"}
            sx={{ borderRadius: "5px" }}
          />
        </>
      ) : showSpinner ? (
        <ButtonComponent tag={<CircularProgress
          size="25px"
          sx={{ color: textColor || "white", margin: "2.5px" }} />} 
          border={borderColor} background={backgroundColor} color={textColor}
            />
      ) : (
            <ButtonComponent tag={tag}
              border={borderColor} background={backgroundColor} color={textColor}
              disabledBackground={disabledBackgroundColor} disabledBorder={disabledBorderColor} disabledColor={disabledTextColor}
              onButtonClick={() => onClickEvent()}
              disabled={disabled}
            />
      )}
    </>
  );
};

export default ApiRequestButton;
